import type { ConstructionProject, ConstructionProjectNew } from "@/views/constructionProject/constructionProject";
import { getLookupDescription, getLookupLongDescriptionWithFallback } from "@modernary/mui/components/lookup";
import { apiService } from "@modernary/mui/utils/api";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
  formatCrossStreets,
};

function addAuthRequestFields(entity: ConstructionProject) {
  entity._authRequestFields = ["id"];
  return entity;
}
function getInitialData() {
  const result = {} as ConstructionProject; //TODO: ts
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: ConstructionProject }) {
  addAuthRequestFields(response.data);

  await formatCrossStreets(response.data);

  return response.data;
}

/** Be sure to await this when using it.  */
async function responseAdapter(response: { data: ConstructionProject }) {
  await skinnyResponseAdapter(response);

  return response.data;
}
function requestAdapter(data: ConstructionProject) {
  return data;
}

async function formatCrossStreets(data: ConstructionProject) {
  //Formatting the cross streets (based on rule that only proximity can be null)
  data.crossStreetsFormatted = `${data.crossStreetFirst}/${data.crossStreetSecond}`;
  if (data.crossStreetProximityMurn) {
    let proximityValue = await getLookupDescription(data.crossStreetProximityMurn);
    data.crossStreetsFormatted += `, ${proximityValue}`;
  }
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit<T extends ConstructionProject | ConstructionProjectNew>(data: T) {
  //TODO: Mask Bug parcel number only set to be undefined to fix formkit bug. Once formkit resolves bug remove
  if (!data.parcelNumber) {
    data.parcelNumber = undefined;
  }
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: ConstructionProject) {
  //TODO: Mask Bug remove this once the if above is removed.
  if (data.parcelNumber === undefined) {
    data.parcelNumber = null;
  }
}
